import React from "react";
import './quota-counter.scss'
import IconPlusNotRounded from "../../icons/icon-plus-not-rounded/icon-plus-not-rounded";
import IconMinus from "../../icons/icon-minus/icon-minus";
import FontBody4 from "../../fonts/font-body4/font-body4";
import {AddonStore} from "../../../pages/accounts/addons-section/stores/addons-store-list";
import {FONT_COLOR} from "../../fonts/font-props";
import {observer} from "mobx-react-lite";
import SubscriptionPlansStore from "../../../pages/subscription-plans/stores/subscription-plans-store";
import FontBody1 from "../../fonts/font-body1/font-body1";

interface IQuotaCounter {
    addon: AddonStore
}

const QuotaCounter: React.FC<IQuotaCounter> = observer(({addon}) => {
    const disabled = SubscriptionPlansStore.isOnTrial;
    
    const formatPrice = (price: number) => {
        if (price < 0) {
            return `- $${Math.abs(price)}`;    
        }
        return `$${price}`;
    }

    return (
        <div className={`quota-counter ${disabled ? 'disabled' : ''}`}>
            <div className="quota-counter-input">
                <div className="input-button" onClick={() => {
                    if (!disabled && addon.featureQuota !== -addon.currentUserQuota) {
                        addon.setFeatureQuota(addon.featureQuota - Number(addon.quotaUnit))
                    }
                }}>
                    <IconMinus/>
                </div>
                <div className="input-value">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>
                        {addon.featureQuota}
                    </FontBody1>
                </div>
                <div className="input-button" onClick={() => {
                    if (!disabled) {
                        addon.setFeatureQuota(addon.featureQuota + Number(addon.quotaUnit))
                    }
                }}>
                    <IconPlusNotRounded/>
                </div>
            </div>
            <div className="quota-counter-step-price">
                <FontBody4 color={FONT_COLOR.NEUTRAL_WHITE}>
                    {formatPrice(addon.featureQuota === 0 ? 0 : addon.addonPrice)}
                </FontBody4>
            </div>
        </div>
    )
});

export default QuotaCounter;